import React, { createRef, forwardRef } from 'react';

import {
  arrayOf,
  bool,
  func,
  node,
  oneOfType,
  shape,
  string
} from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../../../.internal/BaseComponent';

import LeafTrigger from '../../../leaf_trigger/LeafTrigger';

import './MobileMenuCard.scss';

const colorClasses = {
  accent: '-accent',
  negative: '-negative',
  primary: '-primary',
  secondary: '-secondary',
  warm: '-warm',
  white: '-shade'
};

class MobileMenuCard extends BaseComponent {
  constructor(props) {
    super(props);

    this.leafTriggerRef = createRef();
  }

  triggerHandler = () => {
    if (typeof this.onTriggerClick !== 'undefined') {
      this.onTriggerClick();
    }
  };

  componentDidUpdate(prevProps) {
    const { active, onBlur, onFocus } = this.props;

    if (
      typeof onBlur !== 'undefined' &&
      prevProps.active !== active &&
      !active
    ) {
      onBlur();
    }

    if (
      typeof onFocus !== 'undefined' &&
      prevProps.active !== active &&
      active
    ) {
      onFocus();
    }
  }

  render() {
    const {
      active,
      children,
      className,
      color,
      icon,
      onTriggerClick,
      triggerStyle
    } = this.props;

    const cardClassNames = ClassNames([
      'mobile-menu-card',
      className,
      active && 'active',
      color && colorClasses[color]
    ]);

    const triggerClassNames = ClassNames([
      'card-trigger',
      active ? 'active' : undefined
    ]);

    return (
      <div className={cardClassNames}>
        <LeafTrigger
          color={color}
          className={triggerClassNames}
          icon={icon}
          onClick={onTriggerClick}
          ref={this.leafTriggerRef}
          style={triggerStyle}
        />
        {children}
      </div>
    );
  }
}

MobileMenuCard.propTypes = {
  active: bool,
  children: oneOfType([node, arrayOf(node)]),
  className: string,
  color: string,
  icon: string,
  onBlur: func,
  onTriggerClick: func,
  onFocus: func,
  triggerStyle: shape({})
};

MobileMenuCard.defaultProps = {
  active: false,
  children: undefined,
  className: undefined,
  color: 'default',
  icon: undefined,
  onBlur: undefined,
  onTriggerClick: undefined,
  onFocus: undefined,
  triggerStyle: undefined
};

export default forwardRef((props, ref) => (
  <MobileMenuCard {...props} ref={ref} />
));
